module.exports = __webpack_public_path__ + "fonts/Nimbus-Sans-D-OT-Bold-Extended_32745.e96b355.ttf";